import React, { useRef, useState } from 'react';
import Img from './Img';

const pad = (n) => String(n).padStart(2, '0');

/** Crossfading carousel of vertical frames with ‹ 01 / 14 › controls; swipe on touch. */
const PortraitCarousel = ({ images, altFor, onOpen }) => {
  const [index, setIndex] = useState(0);
  const start = useRef(null);
  const count = images.length;
  if (!count) return null;

  const step = (d) => setIndex((i) => (i + d + count) % count);

  const onPointerDown = (e) => {
    start.current = { x: e.clientX, y: e.clientY };
  };
  const onPointerUp = (e) => {
    const s = start.current;
    start.current = null;
    if (!s) return;
    const dx = e.clientX - s.x;
    const dy = e.clientY - s.y;
    if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
    else if (Math.abs(dx) < 6 && Math.abs(dy) < 6) onOpen(images[index]);
  };

  return (
    <section className="pcar" aria-roledescription="carousel" aria-label="Vertical frames">
      <div className="pcar__stage" onPointerDown={onPointerDown} onPointerUp={onPointerUp}>
        {images.map((image, i) => {
          const near = Math.abs(i - index) <= 1 || Math.abs(i - index) === count - 1;
          return (
            <div key={image.src} className="pcar__frame" data-active={i === index ? '' : undefined} aria-hidden={i !== index}>
              {near && <Img image={image} alt={altFor(image)} sizes="(max-width: 1023px) 100vw, 40vw" />}
            </div>
          );
        })}
      </div>
      <div className="pcar__controls">
        <button type="button" className="pcar__arrow" onClick={() => step(-1)} aria-label="Previous frame">
          ‹
        </button>
        <span className="pcar__counter" aria-live="polite">
          {pad(index + 1)} / {pad(count)}
        </span>
        <button type="button" className="pcar__arrow" onClick={() => step(1)} aria-label="Next frame">
          ›
        </button>
      </div>
    </section>
  );
};

export default PortraitCarousel;
